import Vue from 'vue'
import App from './App.vue'
import VueAnalytics from 'vue-analytics'

import {sync} from 'vuex-router-sync'

import {createRouter} from './router'
import {createStore} from './store'

Vue.config.productionTip = false

export function createApp () {
  const router = createRouter()
  const store = createStore()

  sync(store, router)

  if(process.env.NODE_ENV === 'production') {
    Vue.use(VueAnalytics, {
      id: process.env.VUE_APP_ANALYTICS_ID,
      router
    })
  }

  /* eslint-disable no-new */
  const app = new Vue({
    router,
    store,
    render: h => h(App)
  })

  return {app, router, store}
}
